module.exports = __webpack_public_path__ + "media/images/forms-icons/feedback-icon-9cb46ac8427186e50a6b7a81e296243d.svg";